import React, { useState, useEffect } from "react";
import { Card, Grid, makeStyles } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import {
  getBandejas,
  getNomencladorBandeja,
} from "../../../../actions/autorizaciones/Autorizaciones";
import BuscadorAbm from "../../../compartidos/abms/BuscadorAbm";
import TableGeneric from "../../../compartidos/abms/TableGeneric";
import AbmBandejaItem from "./AbmBandejaItem";
import InfoHistorialIcon from "../../UI/InfoHistorialIcon";
import ModalHistoricoTrackingAbm from "../../../compartidos/abms/ModalHistoricoTrackingAbm";


const useStyles = makeStyles({
  root: {
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "1rem",
  },
});

export const AbmPracticaBandejaHome = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { bandejas, nomencladorBandeja } = useSelector(
    (state) => state.autorizaciones
  );

  const [openModalInfo, setOpenModalInfo] = useState(false);
  const [idClave, setIdClave] = useState(false);
  const [descripcion, setDescripcion] = useState(false);

  useEffect(() => {
    dispatch(getBandejas());
    dispatch(getNomencladorBandeja());
  }, [dispatch]);

  const handleSearch = (texto) => {
    dispatch(getNomencladorBandeja(texto));
  };



  return (
    <React.Fragment>
      {openModalInfo && (
        <ModalHistoricoTrackingAbm
          open={openModalInfo}
          onClose={() => setOpenModalInfo(false)}
          idClave={idClave}
          descripcion={descripcion}
          
        />
      )}
      <Grid container justify="center">
        <Grid item xs={12} md={6} className={classes.root}>
          <BuscadorAbm title="Buscar Practica" handleSearch={handleSearch} />
        </Grid>
        <Grid item xs={12} md={9} style={{ marginTop: "2rem" }}>
          <Card>
            <TableGeneric
              data={nomencladorBandeja}
              sizeTableCells={["8", "25%", "75%"]}
              columns={[
                {
                  label: "",
                  id: "",
                  sort: false,
                  customBody: (item) => (
                    <InfoHistorialIcon
                      onClick={() => {
                        setOpenModalInfo(true);
                        setIdClave(item?.idCodNom);
                        setDescripcion(`${item?.nomencladorNacional?.codNom} - ${item?.nomencladorNacional?.desNom}`);
                      }}
                    />
                  ),
                },
                {
                  label: "Practica",
                  id: "nomencladorNacional.desNom",
                  sort: true,
                  customBody: (item) =>
                    `${item?.nomencladorNacional?.codNom} - ${item?.nomencladorNacional?.desNom}`,
                },
                {
                  label: "Bandeja",
                  id: "mobile",
                  sort: false,
                  customBody: (item) => {
                    const aux = Array.isArray(bandejas) &&
                      bandejas.length > 0 && (
                        <AbmBandejaItem item={item} bandejas={bandejas} />
                      );
                    return aux;
                  },
                },
              ]}
            />
          </Card>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};
